<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_long" class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filters" class="dataTables_filter text-md-end">
                  <b-button
                    v-if="user_permissions.add_antibiotic"
                    variant="primary"
                    size="sm"
                    v-b-modal.antbiotic-modal
                    ><i class="fa fa-plus"></i> New Antibiotic</b-button
                  >
                  <button
                    v-else
                    class="btn btn-outline-primary btn-sm"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> New Antibiotic
                  </button>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                bordered
                class="datatables"
                :items="labantibiotics"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(action)="data">
                  <!-- Edit Modal -->
                  <b-button
                    v-if="user_permissions.edit_antibiotic"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-antbiotic-modal
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <button
                    v-else
                    class="btn btn-outline-primary btn-sm"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> Edit
                  </button>
                  |
                  <!-- Delete Modal -->
                  <b-button
                    v-if="user_permissions.delete_antibiotic"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-antbiotic-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash-alt"></i> Delete</b-button
                  >
                  <button
                    v-else
                    class="btn btn-outline-danger btn-sm"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> Delete
                  </button>
                </template>
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!labantibiotics" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add antbiotic model -->
    <b-modal
      hide-footer
      id="antbiotic-modal"
      :title="'ADD NEW ANTIBIOTIC'"
      title-class="font-18"
      @hidden="clearInput(), resetError()"
    >
      <div class="form-group">
        <label class="col-form-label">Antibiotic Name</label>

        <input
          v-model="data.name"
          type="text"
          class="form-control"
          placeholder="Antibiotic Name"
          @input="resetErrors()"
        />
      </div>
      <div class="text-danger" v-if="nameError">
        <em>{{ nameError }}</em>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary float-start"
          @click="closeModal('antbiotic-modal')"
        >
          Cancel
        </button>
        <button
          @click="addAntibiotic('antbiotic-modal')"
          type="submit"
          class="btn btn-success"
        >
          Submit <i class="fa fa-check"></i>
        </button>
        <b-spinner
          v-if="PickingStatus"
          class="m-0"
          variant="primary"
          role="status"
        ></b-spinner>
      </div>
    </b-modal>
    <!-- edit modal starts -->
    <b-modal id="edit-antbiotic-modal" hide-footer @hidden="resetEditAntibiotic">
      <template #modal-title> Edit Antibiotic {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Antibiotic Name</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            @input="resetError()"
            v-model="editdata.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-antbiotic-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editAntibiotic('edit-antbiotic-modal')"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="PickingStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete Antbiotic starts -->
    <b-modal id="delete-antbiotic-modal" hide-footer @hidden="resetDeleteAntibiotic">
      <template #modal-title>
        <h4 class="text-danger">Delete Antibiotic {{ deletedata.name }}</h4></template
      >
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to delete this Antibiotic? Click Proceed Button to delete.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-antbiotic-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteAntibiotic('delete-antbiotic-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="PickingStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
  page: {
    title: "Laboratory Antibiotics",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: "Laboratory Antibiotics",
      items: [
        {
          text: "Laboratory Section",
          href: "#",
        },
        {
          text: "Laboratory Antibiotics",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "antibiotic",
          sortable: true,
          label: "NAME",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "DATE & TIME",
        },
        {
          key: "action",
          sortable: false,
          label: "ACTION",
        },
      ],
      data: {
        name: "",
      },
      // edit position
      editdata: {
        name: "",
        id: "",
      },
      // delete position
      deletedata: {
        name: "",
        id: "",
      },
      modal_id: "",
      nameError: "",
    };
  },

  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("laboratory", ["labantibiotics", "PickingStatus"]),
    ...mapGetters("auth", ["user_permissions"]),

    rows() {
      return this.labantibiotics ? this.labantibiotics.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.labantibiotics ? this.labantibiotics.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchAntibiotic: "laboratory/fetchLabAntibiotics",
      AddAntibiotic: "laboratory/addLabSubstance",
      EditAntibiotic: "laboratory/editLabSubstance",
      DeleteAntibiotic: "laboratory/deleteLabSubstance",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addAntibiotic(modalId) {
      if (this.data.name == "") {
        this.nameError = "Name field is required";
        return;
      } else {
        this.nameError == "";
      }
      this.modal_id = modalId;
      this.AddAntibiotic(this.data);
    },
    clearInput() {
      this.data.name = "";
    },
    resetError() {
      this.nameError = "";
    },
    resetEditAntibiotic() {
      this.editdata.name = "";
      this.editdata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetDeleteAntibiotic() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.antibiotic;
      this.editdata.id = data.item.id;
    },
    editAntibiotic(modalId) {
      this.modal_id = modalId;
      this.EditAntibiotic(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.antibiotic;
      this.deletedata.id = data.item.id;
    },
    deleteAntibiotic(modalId) {
      this.modal_id = modalId;
      this.DeleteAntibiotic(this.deletedata);
    },

    // CLOSE MODEL
    closeModal(model_id) {
      this.clearInput();
      this.resetError();
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
    // END CLOSE MODEL
  },

  created() {
    this.FetchAntibiotic();
  },
};
</script>

<style lang="css" scoped></style>
